import { AutoFields, AutoForm, SubmitField, authReducer, useForm } from '@bitstopco/bitstop-theme';
import type { ModalChildrenProps } from '@bitstopco/bitstop-theme';

import { Button, DialogActions, DialogContent, Divider } from '@mui/material';
import toast from 'react-hot-toast';

import SCHEMAS from '@/forms/schemas';
import { useCreateServiceTicketNoteMutation } from '@/store/api/services/operations/serviceTickets/notes';

import { useAppSelector } from '@/store';
import type { CaseCustomNoteModel } from '@/types';

/**
 * Service Ticket Custom Note Modal
 *
 * @param {ModalChildrenProps} { hide, props }
 */
const ServiceTicketCustomNote = ({ hide, props }: ModalChildrenProps) => {
  const { schema } = useForm(SCHEMAS.SERVICE_TICKET_CUSTOM_NOTE);
  const [createServiceTicketNote] = useCreateServiceTicketNoteMutation();

  const {
    selectors: { userInfo },
  } = authReducer;

  const userData = useAppSelector(userInfo);

  const handleSubmit = async (data: CaseCustomNoteModel) => {
    try {
      await createServiceTicketNote({
        service_ticket_id: props.service_ticket_id,
        note_text: data.content,
        author: `${userData?.first_name} ${userData?.last_name}`,
      }).unwrap();
      toast.success('Note created successfully');
      hide();
    } catch {
      toast.error('Error creating note for this service ticket');
    }
  };

  return (
    <AutoForm<CaseCustomNoteModel> showInlineError schema={schema} onSubmit={handleSubmit}>
      <DialogContent sx={{ my: 2 }}>
        <AutoFields />
      </DialogContent>
      <Divider />
      <DialogActions sx={{ justifyContent: 'space-between' }}>
        <Button onClick={hide}>Back</Button>
        <SubmitField variant="contained">Create Note</SubmitField>
      </DialogActions>
    </AutoForm>
  );
};

export default ServiceTicketCustomNote;
